import { AtlasAttachmentLoader, SkeletonJson, TextureAtlas } from '@esotericsoftware/spine-threejs';
import { atom } from 'jotai';
import Damsel from '../classes/Damsel';
import { Asset } from '../types/damsel';
import { useAsset } from './assets';
import { assetAtom } from '../loader/cache';

const createSkeletonData = (atlas: TextureAtlas, skeleton: any) => {
  const atlasLoader = new AtlasAttachmentLoader(atlas);
  let skeletonJson = new SkeletonJson(atlasLoader);
  return skeletonJson.readSkeletonData(skeleton);
}


export function useMesh(meshName: string) {
  const skeleton = useAsset(`${meshName}.json`)
  const atlas = useAsset(`${meshName}.atlas`) as TextureAtlas
  return new Damsel(createSkeletonData(atlas, skeleton), { damsel: 'heather' })
}

export const damselSkeletonAtom = atom(async (get) => {
  const c = get(assetAtom)
  const skeleton = c[`damsel.json`]
  const atlas = c[`damsel.atlas`] as TextureAtlas
  // console.log(atlas)
  return createSkeletonData(atlas, skeleton)
})

export const toolSkeletonAtom = atom(async (get) => {
  const c = get(assetAtom)
  const skeleton = c[`tools.json`]
  const atlas = c[`tools.atlas`] as TextureAtlas
  // console.log(atlas)
  return createSkeletonData(atlas, skeleton)
})



export function useSkeletonData(meshName: Asset) {

  //const assetCache = useAtomValue(assetAtom)
  const skeleton = useAsset(`${meshName}.json`)
  const atlas = useAsset(`${meshName}.atlas`) as TextureAtlas
  return createSkeletonData(atlas, skeleton)
}

